<template>
  <div class="over-time-order">
    <div class="right">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>道路:</label>
            <search-parking></search-parking>
          </div>

          <div class="form-group">
            <label>收费员</label>
            <input
              v-model="search.chargeName"
              class="form-control"
              type="text"
              placeholder
            />
          </div>
          <div class="form-group">
            <label>统计日期</label>
            <el-date-picker
              v-model="search.chargeDay"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              @change="onDateChange"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
              >
                导出
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="停车道路"
            prop="parkingName"
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip label="泊位号" prop="spaceNum">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="收费员"
            prop="chargeName"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="地磁结束时间"
            prop="nbDate"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="进场时间"
            prop="beginDate"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="出场时间"
            prop="endDate"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="停车时长"
            prop="lotTime"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="统计日期"
            prop="chargeDay"
          >
          </el-table-column>
           <el-table-column
            show-overflow-tooltip
            label="取证类型"
            prop="fbType"
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip label="是否取证">
            <template slot-scope="scope">
              <span v-bind:class='[scope.row.reportingId?"":"gray","normal-reporting"]' @click="onReportingBtn(scope.row)">
                {{ scope.row.reportingStatus }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { getNoOrderList } from "@/api/url";
import SearchParking from "../../commons/searchParking";
import SearchArea from "../../commons/searchArea";
import Page from "../../commons/page";
const dayjs = require("dayjs");
export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageSize: 10,
        pageNumber: 1,
        chargeName: "",
        chargeDay: [dayjs().subtract(30, "day"), dayjs().subtract(1, "day")],
      },
      tableListData: [],
    };
  },

  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    checkDate() {
      const { chargeDay } = this.search;
      if (chargeDay.length < 2) return false;
      if (dayjs(chargeDay[1]).diff(dayjs(chargeDay[0]), "day") > 30) {
        this.$message({
          message: "时间段为30天内",
          type: "warning",
        });
        return false;
      }
      return true;
    },
    onDateChange(v) {
      this.checkDate();
    },
    tableList: function(curPage) {
      if (!this.checkDate()) return;
      let parkingId, areaId;
      if (this.parking) {
        parkingId = this.parking.parkingId;
      }
      if (this.area) {
        areaId = this.area.areaId;
      }
      const { chargeName, chargeDay } = this.search;
      this.$get(getNoOrderList(), {
        parkingId,
        chargeName,
        beginDate: dayjs(chargeDay[0]).format("YYYY-MM-DD"),
        endDate: dayjs(chargeDay[1]).format("YYYY-MM-DD"),
        limit: this.search.pageSize,
        page: curPage,
      }).then((res) => {
        const {
          status,
          data: { rows, total, offset },
        } = res;
        if (status !== 200) {
          this.tableListData = [];
          return;
        }
        var pageObj = {
          curIndex: offset,
          rowsCount: total,
        };
        this.getPage(pageObj);

        this.tableListData = rows ?? [];
      });
    },
    searchList() {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },

    downloadData() {
      const { chargeName, chargeDay } = this.search;
      this.$downloadFileRequest(
        "/api/parking/noOrder/overtimeOrderingExport",
        {
          parkingId: this.parking?.parkingId ?? null,
          chargeName,
          beginDate: dayjs(chargeDay[0]).format("YYYY-MM-DD"),
          endDate: dayjs(chargeDay[1]).format("YYYY-MM-DD"),
        },
        "未下单数据分析"
      );
    },
    onReportingBtn(row){
      const {reportingId}=row
      if(!reportingId) return;
      this.$router.push({path:"/main/inspectorManagement/informationFeedback",query:{reportingId}})
    }
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      area: (state) => state.parking.area,
      parking: (state) => state.parking.oneParking,
    }),
  },
  components: {
    Page,
    SearchParking,
    SearchArea,
  },

  mounted: function() {
    this.tableList(this.search.pageNumber);
  },
};
</script>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.over-time-order .el-date-editor.el-input__inner {
  max-width: 100% !important;
}
.normal-reporting{
  color:#278cd8;
  cursor: pointer;
  font-weight: bold;
}
.gray{
  color:#666;
  cursor:not-allowed;
}
</style>
